<template>
    <div
        v-if="ceiling"
        class="flex items-center gap-1 text-green-600 text font-bold"
        :class="inline ? 'gap-4' : 'flex-col'"
    >
        <span>{{ score }} / {{ ceiling }} {{ $t('segments_game.points_suffix') }}</span>
        <div 
            v-if="!compact"
            class="h-3 overflow-hidden border-2 border-green-600 -skew-10 rotate-10 relative"
            :class="inline ? 'flex-1' : 'w-full'"
        >
            <div
                class="absolute h-full bg-green-600 transition-all duration-300"
                :style="{ width: `${progress}%` }"
            ></div>
        </div>
    </div>
    <div
        v-else
        class="flex items-center text-green-600"
        :class="inline ? 'gap-4' : 'flex-col-reverse gap-3'"
    >
        <span class="text-xs uppercase font-bold text-white bg-bg border-zinc-700 border p-1.5 px-3">{{ $t('game_stats.segments_score') }}</span>
        <span class="text-2xl font-bold leading-none">{{ score }}</span>
    </div>
</template>

<script>
export default {
    name: 'SegmentsPointsProgress',
    props: {
        // The team's running point total this leg.
        score: {
            type: Number,
            default: 0,
        },
        // The points ceiling to fill (Ceiling mode), or null in Rounds mode.
        ceiling: {
            type: Number,
            default: null,
        },
        // Inline (grid layout) vs stacked (vertical layout).
        inline: {
            type: Boolean,
            default: false,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        progress() {
            if (!this.ceiling) return 0
            return Math.min(100, Math.round((this.score / this.ceiling) * 100))
        },
    },
}
</script>
